/* eslint-env jquery */

const Slick = {
  onInit: () => {
    (function ($) {
      $('.newsTicker').slick({
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        vertical: true,
        autoplay: true,
      });
      $('.resource_slider').slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
      });
      // $('.newsTicker').show();
    })(jQuery);
  },
};
export default Slick;
